import { useState, useEffect } from 'react';
import AppLayout from '@/components/feature/AppLayout';

export default function SupNotesPage() {

  const [decisionNotes, setDecisionNotes] =
    useState<any[]>([]);

  const [childCases, setChildCases] =
    useState<any[]>([]);

  const [newNote, setNewNote] =
    useState({

      caseNumber: '',
      note: '',
      type: 'general'

    });

  const [user, setUser] =
    useState<any>(null);

  useEffect(() => {

    const authUser =
      JSON.parse(
        localStorage.getItem('user') || '{}'
      );

    setUser(authUser);

    fetch(
      'https://guardiancloudcare.com/backend/api/get_decision_notes.php'
    )
    .then(res => res.json())
    .then(data => {

      if (Array.isArray(data)) {

        setDecisionNotes(data);

      }

    });

    fetch(
      'https://guardiancloudcare.com/backend/api/get_child_cases.php'
    )
    .then(res => res.json())
    .then(data => {

      if (Array.isArray(data)) {

        setChildCases(data);

      }

    });

  }, []);

  const handleAddNote = async () => {

    if (
      !newNote.caseNumber ||
      !newNote.note
    ) return;

    await fetch(

      'https://guardiancloudcare.com/backend/api/add_decision_note.php',

      {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json'
        },

        body: JSON.stringify({

          uid: user?.uid,

          case_number:
            newNote.caseNumber,

          note:
            newNote.note,

          type:
            newNote.type

        })

      }

    );

    const refreshed =
      await fetch(
        'https://guardiancloudcare.com/backend/api/get_decision_notes.php'
      );

    const refreshedData =
      await refreshed.json();

    setDecisionNotes(refreshedData);

    setNewNote({

      caseNumber: '',
      note: '',
      type: 'general'

    });

  };

  return (

    <AppLayout
      title="Decision Notes"
      breadcrumb={['Supervisor', 'Notes']}
    >

      <div className="space-y-4">

        <div className="bg-white rounded-xl border border-gray-100 p-6">

          <h3 className="font-semibold text-gray-800 mb-4">

            Add Decision Note / Recommendation

          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">

            <div>

              <label className="text-sm font-medium text-gray-700 mb-1.5 block">

                Select Child Case

              </label>

              <select

                value={newNote.caseNumber}

                onChange={(e) =>
                  setNewNote({

                    ...newNote,

                    caseNumber:
                      e.target.value

                  })
                }

                className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm outline-none focus:border-teal-500"

              >

                <option value="">

                  Select child case...

                </option>

                {childCases.map((c) => (

                  <option
                    key={c.case_number}
                    value={c.case_number}
                  >

                    {c.case_number}
                    {' — '}
                    {c.first_name}
                    {' '}
                    {c.last_name}

                  </option>

                ))}

              </select>

            </div>

            <div>

              <label className="text-sm font-medium text-gray-700 mb-1.5 block">

                Note Type

              </label>

              <select

                value={newNote.type}

                onChange={(e) =>
                  setNewNote({

                    ...newNote,

                    type: e.target.value

                  })
                }

                className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm outline-none focus:border-teal-500"

              >

                <option value="general">

                  General Note

                </option>

                <option value="approval">

                  Approval Note

                </option>

                <option value="recommendation">

                  Recommendation

                </option>

                <option value="closure">

                  Closure Note

                </option>

                <option value="escalation">

                  Escalation Note

                </option>

              </select>

            </div>

          </div>

          <div className="mb-4">

            <label className="text-sm font-medium text-gray-700 mb-1.5 block">

              Note / Recommendation

            </label>

            <textarea

              value={newNote.note}

              onChange={(e) =>
                setNewNote({

                  ...newNote,

                  note: e.target.value

                })
              }

              rows={4}

              maxLength={500}

              placeholder="Enter supervisory note or recommendation..."

              className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm outline-none focus:border-teal-500 resize-none"

            />

            <p className="text-xs text-gray-400 text-right mt-1">

              {newNote.note.length}/500

            </p>

          </div>

          <button

            onClick={handleAddNote}

            disabled={
              !newNote.caseNumber ||
              !newNote.note
            }

            className="bg-teal-500 text-white text-sm px-5 py-2.5 rounded-xl hover:bg-teal-600 disabled:bg-teal-300 flex items-center gap-2"

          >

            <i className="ri-sticky-note-line" />

            Add Note

          </button>

        </div>

        <div className="space-y-3">

          {decisionNotes.map((n) => (

            <div
              key={n.id}
              className="bg-white rounded-xl border border-gray-100 p-5"
            >

              <div className="flex items-start justify-between gap-2 mb-2">

                <div className="flex items-center gap-2 flex-wrap">

                  <span className="text-xs font-mono bg-gray-100 text-gray-600 px-2 py-0.5 rounded">

                    {n.case_number}

                  </span>

                  <span className="text-xs bg-teal-100 text-teal-700 px-2 py-0.5 rounded-full">

                    {n.first_name}
                    {' '}
                    {n.last_name}

                  </span>

                  <span
                    className={`text-xs px-2 py-0.5 rounded-full font-medium capitalize ${
                      n.type === 'approval'
                        ? 'bg-green-100 text-green-700'

                        : n.type === 'closure'
                        ? 'bg-gray-100 text-gray-600'

                        : 'bg-teal-100 text-teal-700'
                    }`}
                  >

                    {n.type}

                  </span>

                </div>

                <span className="text-xs text-gray-400">

                  {n.created_at}

                </span>

              </div>

              <p className="text-sm text-gray-700">

                {n.note}

              </p>

              <p className="text-xs text-gray-400 mt-2">

                — {n.supervisor_name}

              </p>

            </div>

          ))}

        </div>

      </div>

    </AppLayout>

  );

}